import React from 'react'
import { Box, makeStyles, Typography } from '@material-ui/core';

const Usestyles=makeStyles({
    wrapper:{
        width:'100vw',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        /*backgroundColor:'yellow',*/
        height:'100vh',
        overflowY:'hidden',
        '@media only screen and (max-width: 420px)':{
            width:'100vw',
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            /*backgroundColor:'yellow',*/
            flexDirection:'column',
            height:'100vh'
        }
    },
    image:{
        height:'60%',
        width:'80%'
    },
    textbox:{
        fontSize:'64px',
        /*backgroundColor:'yellow',*/
        flex:6,
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        '@media only screen and (max-width: 420px)':{
            fontSize:'36px',
            flex:6,
            display:'flex',
            alignItems:'start',
            justifyContent:'center',
            padding:'5%'
        }
    },
    imagebox:{
        flex:6,
        /*backgroundColor:'blue',*/
        display:'flex',
        alignItems:'center',
        justifyContent:'center'
    }
});

const CommingSoon = () => {
    const classes=Usestyles();
    return (
        <div className={classes.wrapper} >
            <Box className={classes.imagebox}>
                <img className={classes.image} src='https://www.ignitingbusiness.com/images/easyblog_images/382/the-difference-between-a-cms-and-a-website-builder-platform.jpeg'/>
            </Box>
            <Typography className={classes.textbox}>
                This session will be live soon..
            </Typography>
        </div>
    )
}

export default CommingSoon
